import type { ReactNode } from 'react';

import { table } from '@/components/ui/styles';

/** The table view that sits beside each report chart (dataviz: a table view always exists). */
const TableCard = ({ title, aside, children }: { title: string; aside?: ReactNode; children: ReactNode }) => (
  <section className={table.wrap}>
    <div className="flex items-center justify-between gap-2 px-4 pb-1 pt-4">
      <h2 className="text-sm font-medium text-fg-strong">{title}</h2>
      {aside}
    </div>
    <div className="overflow-x-auto">
      <table className={table.table}>{children}</table>
    </div>
  </section>
);

export default TableCard;
